import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {RECAPTCHA_ACTIONS} from '../../../constants/recaptcha';
import {TYPE_CLICK} from '../../../constants/tagManager';
import {PARTNERS_TYPES, P_LIST_TYPES} from '../../../constants/typesMessages';
import {useGetConditions} from '../../../hooks/useGetConditions';
import {useGetProductsCnae} from '../../../hooks/useGetProductsCnae';
import {useRecaptchaProtection} from '../../../hooks/useRecaptchaProtection';
import {isPartnerAnswer} from '../../../services/Api';
import {newCheckErrors} from '../../../services/errorsMessages';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../../services/tagManager';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';

const MessagePartnersOwnerQuestion = (props) => {
  const ecStateId = useEcStore((state) => state.ec.id);
  const repData = useEcStore((state) => state.ec.representativeData);
  const updatePartners = useEcStore((state) => state.updatePartners);
  const setMessages = useChatStore((state) => state.setMessages);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const setPartnersTypeList = useInteractionStore(
    (state) => state.setPartnersTypeList
  );
  const [hidden, setHidden] = useState('');
  const {executeWithProtection} = useRecaptchaProtection();
  useGetProductsCnae();
  useGetConditions();

  const requestIsPartner = (answer, nextStep) => {
    setHidden('hidden');
    setDotTyping(true);
    executeWithProtection(
      (payload, token) => isPartnerAnswer(ecStateId, payload, token),
      RECAPTCHA_ACTIONS.DATA_UPDATE,
      answer
    )
      .then(() => {
        setDotTyping(false);
        if (answer.isPartner) {
          let partnerOwner = {
            id: 1,
            partnerName: repData.displayName,
            cpf: repData.cpf,
            birthDate: repData.birthDate,
            email: repData.email,
            phone: repData.telephoneNumber
          };
          updatePartners([partnerOwner]);
        }

        setMessages(nextStep.messages);
        responseFlowChange(nextStep.responseFlowChange);
        responseTypeChange(nextStep.responseTypeChange);
        setPartnersTypeList(nextStep.partnersTypeList);
      })
      .catch((error) => {
        setDotTyping(false);
        setHidden('');
        const showResponse = newCheckErrors(error, '');
        setMessages(showResponse.messages);
      });
  };

  const isOwner = () => {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-12:none:proprietario-sim'
    });
    let nextStep = {
      messages: [
        {
          text: 'Sim',
          type: 'response-sent'
        },
        {
          text: 'Você tem sócias ou sócios em seu estabelecimento?',
          type: PARTNERS_TYPES.HAS_PARTNERS
        }
      ],
      responseFlowChange: '',
      responseTypeChange: 'disabled',
      partnersTypeList: P_LIST_TYPES.P_OWNER
    };
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-13:none:socios-sim'
    });
    requestIsPartner({isPartner: true}, nextStep);
  };

  const noOwner = () => {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-12:none:proprietario-nao'
    });
    let nextStep = {
      messages: [
        {
          text: 'Não',
          type: 'response-sent'
        },
        {
          text: 'Quantas pessoas fazem parte do quadro societário do seu estabelecimento?',
          type: 'message-receive'
        }
      ],
      responseFlowChange: '',
      responseTypeChange: 'define-number-partners',
      partnersTypeList: P_LIST_TYPES.P_EMPTY
    };
    requestIsPartner({isPartner: false}, nextStep);
  };

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.question.id}`}
          data-aut-test="message-receive-text"
          data-testid="message-receive-text"
        >
          <div
            className="message-div"
            data-aut-test="message-partners-text-questions"
            data-testid="message-partners-text-questions"
          >
            {props.question.text}
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className={`message-line ${hidden}`}
          id={`button-option-partners-is-owner-${props.question.id}`}
          data-testid="button-option-partners-is-owner"
          data-aut-test="button-option-partners-is-owner"
        >
          <div className="div-button">
            <button
              id="no-owner"
              data-aut-test="no-owner"
              data-testid="no-owner"
              type="button"
              onClick={() => noOwner()}
            >
              NÃO
            </button>
            <button
              id="is-owner"
              data-aut-test="is-owner"
              data-testid="is-owner"
              type="button"
              onClick={() => isOwner()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessagePartnersOwnerQuestion.propTypes = {
  question: PropTypes.object
};

export default MessagePartnersOwnerQuestion;
